module.exports = __webpack_public_path__ + "img/logo-sm.e6147c07.png";